import { BackupModel } from './backup.model';

export class BackupFactory {
  public static new(data?: Partial<BackupModel>): BackupModel {
    return new BackupModel(data);
  }

  public static getModel(): any {
    return BackupModel;
  }

  public static getPath(): string {
    return 'backups';
  }
}
